import TemplateView from '../../../../../TemplateView'
import PaymentMethodChooser from './PaymentMethodChooser'
import TransferContent from './TransferContent'
import CheckContent from './CheckContent'
import AdditionalInvoiceDetails from './AdditionalInvoiceDetails'
import {CardBrandType, paymentMethod} from '../../../constants'
import CreditCardContent from './CreditCardContent'
import {connect} from '../../../../../redux/utils'
import {
    getAddress,
    getCardNumber,
    getCity,
    getCountry,
    getEditable,
    getExpiredMonth,
    getExpiredYear,
    getHolderName,
    getState,
    getZip,
    isAddressFormOpen,
    isNeedToSaveCard
} from '../../creditCard/selectors'
import {fieldsChangeAction, resetCardForEdit, setAddressFormOpen, setStripeFieldsValid, toggleNeedSaveCard} from '../../creditCard/actions'
import {bindActionCreators} from 'redux'
import {preparePaymentStep, setPaymentMethod, setPoNumber, setVatNumber} from '../actions'
import {canPayByCheck, canPayByWireTransfer, getPaymentMethod, getPaymentMethodFeeAmount, getPoNumber, getVatNumber, haveSavedCard} from '../selectors'
import {getCountries, getMinWireTransferAmount, getStatesByCountry} from '../../../selectors'
import SaveCardDetailsHeader from '../../creditCard/SaveCardDetailsHeader'

class PaymentContent extends TemplateView {

    constructor({
        setPaymentMethod = () => {},
        fieldsChangeAction = () => {},
        setStripeFieldsValid = () => {},
        setAddressFormOpen = () => {},
        revertToSavedCard = () => {},
        replaceCardCallback = () => {},
        setValueSaveCardCheckbox = () => {},
        setVatNumber = () => {},
        setPoNumber = () => {},
    }) {
        super()

        this.actions = {
            setPaymentMethod,
            fieldsChangeAction,
            setStripeFieldsValid,
            setAddressFormOpen,
            revertToSavedCard,
            replaceCardCallback,
            setValueSaveCardCheckbox,
            setVatNumber,
            setPoNumber,
        }

        this.state = {
            paymentMethod: paymentMethod.CC,

            cardType: CardBrandType.NONE,
            cardNumber: '',
            holderName: '',
            expiredMonth: '',
            expiredYear: '',
            address: '',
            city: '',
            zip: '',
            country: '',
            state: '',
            countries: [],
            statesByCountry: {},
            editable: false,
            isAddressFormOpen: false,
            canPayByWireTransfer: true,
            canPayByCheck: true,
            haveSavedCard: false,
            minWireTransferAmount: 0,
            feeAmount: 0,
            needToSaveCard: false,

            vatNumber: '',
            poNumber: '',
        }

        this.onAnyStatePropertyChanged(['isAddressFormOpen', 'paymentMethod', 'canPayByCheck'], () => {

            this.$cardPayment.toggle(this.state.paymentMethod === paymentMethod.CC)
            this.$transferPayment.toggle(this.state.paymentMethod === paymentMethod.WIRE)
            this.$checkPayment.toggle(this.state.paymentMethod === paymentMethod.CHECK)

            this.paumentMethodChooser.setState({
                paymentMethod: this.state.paymentMethod,
                canPayByCheck: this.state.canPayByCheck
            })
        })

        this.onAnyStatePropertyChanged(['haveSavedCard', 'editable', 'paymentMethod'], () => {
            this.$creditCardHeader.toggle(this.state.paymentMethod === paymentMethod.CC && !this.state.haveSavedCard)
            this.creditCardHeaderWithControls.toggle(this.state.paymentMethod === paymentMethod.CC && this.state.haveSavedCard)

            this.creditCardHeaderWithControls.setState({
                isClear: this.state.editable
            })

            this.$otherPaymentMethodsHeader.toggle(this.state.paymentMethod !== paymentMethod.CC)
        })

        this.onAnyStatePropertyChanged(['canPayByWireTransfer', 'minWireTransferAmount', 'feeAmount'], () => {
            this.$transferPayment.toggleClass('disabled', !this.state.canPayByWireTransfer)
            this.transferPayment.setState({
                canPayByWireTransfer: this.state.canPayByWireTransfer,
                minWireTransferAmount: this.state.minWireTransferAmount,
                fee: this.state.feeAmount,
            })
        })

        this.onAnyStatePropertyChanged(['vatNumber', 'poNumber'], () => {
            this.invoiceDetail.setState({
                vatNumber: this.state.vatNumber,
                poNumber: this.state.poNumber,
            })
        })

        this.onStateChanged(() => {
            this.cardPayment.setState(this.state)
        })
    }

    templateHtml() {
        return '<div class="paymentContent">' +
               '    <div class="paymentChooser"/>' +
               '    <div class="paymentTitle title">' +
               '        <div class="creditCardHeaderWithControls"></div>' +
               '        <div class="creditCardHeader"><%=creditCardHeader%></div>' +
               '        <div class="otherPaymentMethodsHeader"><%=otherPaymentMethods%></div>' +
               '    </div>' +
               '    <div class="cardPayment"/>' +
               '    <div class="transferPayment"/>' +
               '    <div class="checkPayment"/>' +
               '    <div class="invoiceDetail"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            otherPaymentMethods: 'licenses.purchase.purchase_step.payment_details',
            creditCardHeader: 'licenses.purchase.purchase_step.enter_card_details'
        }
    }

    afterRender() {
        this.paumentMethodChooser = new PaymentMethodChooser({
            onCreditCardButtonClick: () => this.actions.setPaymentMethod(paymentMethod.CC),
            onTransferButtonClick: () => this.actions.setPaymentMethod(paymentMethod.WIRE),
            onCheckButtonClick: () => this.actions.setPaymentMethod(paymentMethod.CHECK),
        }).init(this.find('.paymentChooser'))

        this.$creditCardHeader = this.find('.creditCardHeader')
        this.$otherPaymentMethodsHeader = this.find('.otherPaymentMethodsHeader')

        this.$creditCardHeaderWithControls = this.find('.creditCardHeaderWithControls')
        this.creditCardHeaderWithControls = new SaveCardDetailsHeader({
            replaceCardCallback: this.actions.replaceCardCallback,
            rollbackCallback: this.actions.revertToSavedCard,
        }).init(this.$creditCardHeaderWithControls)

        this.$cardPayment = this.find('.cardPayment')
        this.cardPayment = new CreditCardContent({
            fieldsChangeAction: this.actions.fieldsChangeAction,
            setStripeFieldsValid: this.actions.setStripeFieldsValid,
            addressFormOpenToggleAction: this.actions.setAddressFormOpen,
            saveCardCheckboxCallback: this.actions.setValueSaveCardCheckbox,
        }).init(this.$cardPayment)

        this.$transferPayment = this.find('.transferPayment')
        this.transferPayment = new TransferContent().init(this.$transferPayment)

        this.$checkPayment = this.find('.checkPayment')
        this.checkPayment = new CheckContent().init(this.$checkPayment)

        this.invoiceDetail = new AdditionalInvoiceDetails({
            vatNumberChangeCallback: this.actions.setVatNumber,
            poNumberChangeCallback: this.actions.setPoNumber,
        }).init(this.find('.invoiceDetail'))

        this.$title = this.find('.paymentTitle.title')
    }

    getStripeElements() {
        return this.cardPayment.getStripeElements()
    }

    clearStripeElements() {
        return this.cardPayment.clearStripeElements()
    }
}

export default connect(
    (state) => ({
        paymentMethod: getPaymentMethod(state),
        cardBrand: CardBrandType.NONE,
        cardNumber: getCardNumber(state),
        holderName: getHolderName(state),
        expiredMonth: getExpiredMonth(state),
        expiredYear: getExpiredYear(state),
        address: getAddress(state),
        city: getCity(state),
        zip: getZip(state),
        country: getCountry(state),
        state: getState(state),
        countries: getCountries(state),
        statesByCountry: getStatesByCountry(state),
        editable: getEditable(state),
        isAddressFormOpen: isAddressFormOpen(state),
        canPayByWireTransfer: canPayByWireTransfer(state),
        canPayByCheck: canPayByCheck(state),
        haveSavedCard: haveSavedCard(state),
        minWireTransferAmount: getMinWireTransferAmount(state),
        needToSaveCard: isNeedToSaveCard(state),
        vatNumber: getVatNumber(state),
        poNumber: getPoNumber(state),
        feeAmount: getPaymentMethodFeeAmount(state),
    }),
    (dispatch) => ({
        setPaymentMethod: bindActionCreators(setPaymentMethod, dispatch),
        fieldsChangeAction: bindActionCreators(fieldsChangeAction, dispatch),
        setStripeFieldsValid: bindActionCreators(setStripeFieldsValid, dispatch),
        setAddressFormOpen: bindActionCreators(setAddressFormOpen, dispatch),
        revertToSavedCard: bindActionCreators(preparePaymentStep, dispatch),
        replaceCardCallback: bindActionCreators(resetCardForEdit, dispatch),
        setValueSaveCardCheckbox: bindActionCreators(toggleNeedSaveCard, dispatch),
        setVatNumber: bindActionCreators(setVatNumber, dispatch),
        setPoNumber: bindActionCreators(setPoNumber, dispatch),
    })
)(PaymentContent)




// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/paymentStep/PaymentContent.js